export const bufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  };

  export const buildPromotionPayload = (selectedColor, motivation, basePayload) => {
    const payload = { ...basePayload };
    switch (selectedColor.toLowerCase()) {
      case "yellow":
        payload.yellowColorAwarded = true;
        payload.yellowNote = motivation;
        payload.yellowPromoApproved = false;
        break;
  
      case "blue":
        payload.blueColorAwarded = true;
        payload.blueNote = motivation;
        payload.bluePromoApproved = false;
        break;
  
      case "red":
        payload.redColorAwarded = true;
        payload.redNote = motivation;
        payload.redPromoApproved = false;
        break;
  
      case "green":
        payload.greenColorAwarded = true;
        payload.greenNote = motivation;
        payload.greenPromoApproved = false;
        break;
  
      default:
        throw new Error("Invalid color selected");
    }
  
    return payload;
  };

  export const calculateAge = (birthday) => {
    const birthDate = new Date(birthday);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  export const formatDateTime = (dateTime) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateTime).toLocaleString('sv-SE', options);
  };

  export const getMembershipStatusPill = (status) => {
    switch (status) {
      case "Paid":
        return { labelKey: "paid_label", color: "success" };
      case "Not Invoiced":
        return { labelKey: "not_invoiced_label", color: "warning" };
      case "Invoiced":
        return { labelKey: "invoiced_label", color: "info" };
      case "Expired":
        return { labelKey: "expired_label", color: "error" };
      default:
        return { labelKey: "unknown_status", color: "default" };
    }
  };